import Dialog from '@mui/material/Dialog';
import QRCode from 'react-qr-code';
import { ProfileIdentityKind } from '@loyalty/shared-common/profile-api-client';
import { renderToString } from 'react-dom/server';
import { useState } from 'react';
import { uuid } from '@loyalty/shared-common';
import { GenericComponent } from '../../components-tree';
import { ReactBootstrap } from '../../ReactBootstrap';
import { WidgetProps } from '../render-component';

// eslint-disable-next-line
export interface QrCodeDataComponentAttributes {} // This widget has no attributes

export type QrCodeDataComponent = GenericComponent<QrCodeDataComponentAttributes>;

const CLASSNAME = 'qlfeditor-qrcode-data';

export type QrCodeDataWidgetBackendProps = WidgetProps<QrCodeDataComponent>;

interface QrCodeDataWidgetFrontendProps {
  id: string;
  attributes: QrCodeDataComponent['attributes'];
  memberCode?: string;
}

export function serializeQrCodeDataComponentProps({
  state,
  options,
}: QrCodeDataWidgetBackendProps): QrCodeDataWidgetFrontendProps {
  const { profile, programId } = state;
  const identity = profile.identities?.find(
    identity =>
      identity.kind === ProfileIdentityKind.memberCode && identity.programId === programId,
  );
  const memberCode = identity?.value;
  return {
    id: options.id || options.attributes.id || uuid(),
    attributes: options.attributes,
    memberCode,
  };
}

export function QrCodeComponent(minProps: QrCodeDataWidgetFrontendProps) {
  const { memberCode, id, attributes } = minProps;
  const { class: className } = attributes;
  const [open, setOpen] = useState(false);

  const qrCodeComponent = (
    <QRCode
      size={256}
      style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
      value={memberCode || 'no data'}
      viewBox={`0 0 256 256`}
    />
  );

  return (
    <div className={`${CLASSNAME} ${className || ''}`}>
      <>
        <div
          className={`${CLASSNAME}__button__div`}
          style={{ display: 'none' }}
          onClick={() => setOpen(true)}
        >
          <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
        </div>
        {qrCodeComponent}
        <div className={`${CLASSNAME}__value`}>{memberCode}</div>
        <Dialog open={open} onClose={() => setOpen(false)}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: '100%',
              justifyContent: 'center',
              margin: '5px',
            }}
          >
            {qrCodeComponent}
            <div className="qlfeditor-qrcode-data__value">{memberCode}</div>
          </div>
        </Dialog>
      </>
    </div>
  );
}

export function QrCodeDataRenderer(
  props: QrCodeDataWidgetBackendProps,
  document?: Document,
): string {
  const reactProps = serializeQrCodeDataComponentProps(props);
  return renderToString(
    <ReactBootstrap
      component="QrCodeComponent"
      props={reactProps}
      document={document}
      componentType="qrcode-data"
    />,
  );
}
